import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import { Navigate, Route } from "react-router-dom";
import { isLoggedIn } from "../utils/Auth";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import { themeOptions } from "../theme";

const AdminRoute = ({ component: Component, ...rest }) => {
  const [isAuthorized, setIsAuthorized] = useState(false);
  const isLoggedIn2 = isLoggedIn();

  const userRole = useSelector((state) => state.userDetailsReducer?.role);

  const theme = createTheme(themeOptions);

  useEffect(() => {
    if (userRole === "admin" || userRole === "super") {
      setIsAuthorized(true);
    } else {
      setIsAuthorized(false);
    }
  }, [userRole]);

  return isLoggedIn2 && isAuthorized ? (
    <ThemeProvider theme={theme}>
      <Component />
    </ThemeProvider>
  ) : (
    <Navigate to="/" />
  );
};

export default AdminRoute;
